(function () {
  'use strict';

  angular
    .module('app.category.service', [])

    /* @ngInject */
    .factory('CategoryCacheService', ["$cacheFactory", function ($cacheFactory) {
      var cache = $cacheFactory('categoryCache');
      return {
        set: function (key, page, obj) {
          cache.put(key, [page, obj]);
        },
        get: function (key) {
          return cache.get(key);
        },
        reset: function () {
          cache.removeAll();
        }
      };
    }])

    /* @ngInject */
    .factory('CategoryFiltersCacheService', ["$cacheFactory", function ($cacheFactory) {
      var cache = $cacheFactory('filtersCache');
      return {
        set: function (key, obj) {
          cache.put(key, obj);
        },
        get: function (key) {
          return cache.get(key);
        }
      };
    }])

    /* @ngInject */
    .factory('CategoryService', ["$filter", "RoutingService", "HttpService", function ($filter, RoutingService, HttpService) {
      var ctrl;
      return {
        setGridCtrl: function (value) {
          ctrl = value;
        },
        getGridCtrl: function () {
          return ctrl;
        },
        getFilters: getFilters,
        setProducts: setProducts,
        getProducts: getProducts
      };

      // Functions

      function getFilters(idCategory) {
        return HttpService.post({
          url: '/Search/Query',
          data: {
            QueryFullText: '',
            NbFrom: '0',
            NbSize: '0',
            FiltersSelected: [
              {
                FieldName: 'IDCatalogueTheme',
                FieldValue: String(idCategory)
              }
            ]
          }
        })
        .then(function (data) {
          return data;
        })
        .catch(function (error) {
          console.error(error);
        });
      }

      function setProducts(data) {
        var i,
          j,
          len = data.length,
          arr = [];
        for (i = 0; i < len; i++) {
          var obj = {},
            current = data[i];

          obj.IDProduct = current.IDProduct;
          obj.Designation = current.Designation;
          obj.URL = current.URL;
          obj.IDPicture = current.MainPicture ? current.MainPicture.IDPicture : current.IDPicture;
          obj.ReviewsInfo = {Count: current.ReviewsInfo.Count, Average: Math.round(current.ReviewsInfo.Average)};
          obj.Themes = current.Themes;
          obj.HTMLShortDescription = current.HTMLShortDescription;
          obj.Price = current.Price;
          obj.Availability = current.Availability.AvailabilityMessage;
          obj.URL = current.URL;
          obj.IsGroupingProduct = current.IsGroupingProduct;
          obj.IsCustomizable = current.IsCustomizable;
          obj.AllowAddToCart = current.AllowAddToCart;
          for (j = 0; j < obj.Themes.length; j++) {
            var th = obj.Themes[j];
            if (th.KeyTheme === 'Comparateur') {
              obj.isComparable = true;
            }
          }
          /* Optionnal
          obj.Brand = current.Brand;
          if (current.Properties && current.Properties.length) {
            var properties = {};
            _.each(current.Properties, function (prop) {
              properties[prop.KeyProperty] = prop.Value;
            });
            obj.Properties = properties;
          }
          */

          arr.push(obj);
        }
        return arr;
      }

      function getProducts(page, filtered, sort, facets, brands, reviews, themegroups, themes, types, prices, search, idCategory, nbPerPage) {
        if (!filtered) {
          var routing = RoutingService.get(),
            url;

          if (search === '') {
            url = routing.to.originalPath
              .replace(':categoryName', routing.to.params.categoryName)
              .replace(':categoryId', routing.to.params.categoryId.split('-')[0])
              .replace('/:sortType', '');
            url += sort !== '' ? '-' + page + '/' + sort : '-' + page;
          } else {
            url = routing.to.originalPath
              .replace('/:q', '');
            url += '?q=' + search + '&p=' + page;
          }

          return HttpService.get({
            url: url,
            cache: true
          })
          .then(function (data) {
            data.products = setProducts(data.products);
            return data;
          })
          .catch(function (error) {
            console.error(error);
          });
        }
        var sortParam = null;
        if (sort !== '') {
          switch (sort) {
            case 'ALPHAASC':
              sortParam = { FieldName: 'ArtDesignation', SortType: 'asc' };
              break;
            case 'ALPHADESC':
              sortParam = { FieldName: 'ArtDesignation', SortType: 'desc' };
              break;
            case 'PRICEASC':
              sortParam = { FieldName: 'PrixTTC', SortType: 'asc' };
              break;
            case 'PRICEDESC':
              sortParam = { FieldName: 'PrixTTC', SortType: 'desc' };
              break;
          }
        }
        return HttpService.post({
          url: '/Search/Query',
          data: {
            QueryFullText: search,
            NbFrom: (page - 1) * nbPerPage,
            NbSize: nbPerPage,
            FiltersSelected: [
              {
                FieldName: 'IDCatalogueTheme',
                FieldValue: String(idCategory)
              }
            ],
            FacetsSelected: facets,
            BrandsSelected: brands,
            ReviewsSelected: reviews,
            ThemeGroupsSelected: themegroups,
            ThemesSelected: themes,
            ProductTypesSelected: types,
            PriceRangeSelected: prices,
            Sort: sortParam
          }
        })
        .then(function (data) {
          data.products = setProducts(data.products);
          return data;
        })
        .catch(function (error) {
          console.error(error);
        });

      }
    }]);

})();
